import * as bootstrap from 'bootstrap';
import naja from "naja";

class CTToast {
	#bootstrap;
	#naja;

	constructor() {
		this.#bootstrap = bootstrap;
		this.#naja = naja;
	}

	init() {
		this.#addEventListeners();
		//Zpřístupní showCTtoast globálně
		//ToDo: Kontrola, kde všude se používá CTToast a přesměrování sem
		window.showCTtoast = this.showCTtoast.bind(this);
	}

	#addEventListeners() {

	}

	showCTtoast(title, body, type) {

		const toastContainer = document.getElementById("toast-container");
		const toastTemplateHtml = document.getElementById("toastTemplate").innerHTML
			.replace('##toast-title##', title)
			.replace('##toast-body##', body)
			.replace('##toast-type##', 'text-' + type);
		toastContainer.insertAdjacentHTML("beforeend", toastTemplateHtml);

		const toastEl = toastContainer.lastElementChild;
		const toast = new bootstrap.Toast(toastEl, {
			animation: true,
			autohide: true,
			delay: 3000
		});
		toast.show();

		toastEl.addEventListener('hidden.bs.toast', (event) => {
			event.target.remove();
		});
	}
}

export default new CTToast();